export class HistoryEntryDto {
  DateTime: Date;
  DeviceName: string;
  LicensePlate: string;
  IsManual: boolean;
  UserEmail: string;
  Source: string;
  DeviceLatitude: number | null;
  DeviceLongitude: number | null;
  ClientLatitude: number | null;
  ClientLongitude: number | null;
  EventType: string;
  LockCurrentStatus: string;
  DoorCurrentStatus: string;
  RequestedValue: string;
  Message: string;

  constructor(data: Partial<HistoryEntryDto> = {}) {
    this.DateTime = data?.DateTime ?? new Date();
    this.DeviceName = data?.DeviceName ?? '';
    this.LicensePlate = data?.LicensePlate ?? '';
    this.IsManual = data?.IsManual ?? false;
    this.UserEmail = data?.UserEmail ?? '';
    this.Source = data?.Source ?? '';
    this.DeviceLatitude = data?.DeviceLatitude ?? null;
    this.DeviceLongitude = data?.DeviceLongitude ?? null;
    this.ClientLatitude = data?.ClientLatitude ?? null;
    this.ClientLongitude = data?.ClientLongitude ?? null;
    this.EventType = data?.EventType ?? '';
    this.LockCurrentStatus = data?.LockCurrentStatus ?? '';
    this.DoorCurrentStatus = data?.DoorCurrentStatus ?? '';
    this.RequestedValue = data?.RequestedValue ?? '';
    this.Message = data?.Message ?? '';
  }
}